import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Observable, of, switchMap } from 'rxjs';
import { CourseSection } from 'src/app/model/course-section';
import { HelperService } from 'src/app/service/helper.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';

@Injectable({
  providedIn: 'root'
})
export class CoursesectionDataService extends DefaultDataService<CourseSection>{

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator, public urlProvider: UrlProviderService, public helperService: HelperService) {
    super('CourseSection', http, httpUrlGenerator);
}

override getAll(): Observable<CourseSection[]> {
    const url = this.urlProvider.getUrl(EndPoints.get_courseSections, undefined, undefined);
    return this.http
        .get(
            url,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        )
        .pipe(
            switchMap((res: any) => {
                return of(<CourseSection[]>JSON.parse(res.body['courseSections']));                
            })
        );
}
}
